import {SealDocumentCommandHandler} from './seal-document.command-handler';
import {DocumentViewModel} from '../../modules/store';
import {DomainCommand} from '../../modules/command-bus/command';

export class SealDocumentCommand extends DomainCommand {
  constructor(payload: { viewModel: DocumentViewModel, email?: string }) {
    super(SealDocumentCommandHandler, payload);
  }
}
